import useTypewriter from "@/hooks/useTypewriter";

const PREFIX = "Seu negócio merece uma ";
const HIGHLIGHT = "infraestrutura digital";
const SUFFIX = " à altura.";
const FULL = `${PREFIX}${HIGHLIGHT}${SUFFIX}`;

/**
 * Título principal da hero com efeito de máquina de escrever,
 * mantendo o destaque em gradiente na expressão "infraestrutura digital".
 */
export default function HeroHeadline() {
  const { displayed, done } = useTypewriter(FULL, 45, 400);

  const before = PREFIX.slice(0, Math.min(displayed.length, PREFIX.length));
  const rest = displayed.length > PREFIX.length ? displayed.slice(PREFIX.length) : "";
  const highlight = rest.slice(0, HIGHLIGHT.length);
  const after = rest.slice(HIGHLIGHT.length);

  return (
    <>
      <span>{before}</span>
      <span className="bg-gradient-to-r from-primary-400 to-accent-400 bg-clip-text text-transparent">
        {highlight}
      </span>
      <span>{after}</span>
      {!done ? (
        <span
          className="ml-0.5 inline-block h-[0.85em] w-[3px] translate-y-[0.08em] animate-blink bg-accent-400 align-baseline"
          aria-hidden="true"
        ></span>
      ) : null}
    </>
  );
}